"use client";
import ArrowLeftIcon from "@/assets/icons/arrow-left.svg?react";
import ArrowRightIcon from "@/assets/icons/arrow-right.svg?react";
import ChevronDown from "@/assets/icons/chevron-down.svg?react";
import NoImage from "@/assets/images/no_image.svg";
import { AvailablePromotion, TranslationData, VariantItem } from "@/common/lib/types";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { cn } from "@/lib/tailwind";
import { getCloudinaryURL } from "@/utils/cloudinary";
import { useEffect, useState } from "react";
import Collapse from "../collapse/Collapse";
import { Carousel, Slide } from "../ui/carousel/Carousel";
import CldImage from "../ui/cldImg/CldImage";

interface IProps {
  productVariants: VariantItem[];
  promotionalDetails: AvailablePromotion[];
  handleSelectVariant: (item: VariantItem) => void;
  selectedVariant: VariantItem;
  translations?: TranslationData;
  openVariantCarousel: boolean;
  handleOpenVariantCarousel: (val: boolean) => void;
}

const ProductVariantsCarousel = ({
  productVariants,
  promotionalDetails,
  handleSelectVariant,
  selectedVariant,
  translations,
  handleOpenVariantCarousel,
  openVariantCarousel,
}: IProps) => {
  // states
  const [once, setOnce] = useState(false);

  // hooks
  const isMobile = useMediaQuery("(max-width: 768px)");

  const chevronEnabled = productVariants?.length > 3;

  const getUrl = (item: VariantItem) => {
    console.log({ item });
    // if (item?.media[0]?.url.startsWith("/")) {
    //   return getCloudinaryURL(item?.media[0]?.url) ?? NoImage.src;
    // } else return item?.media[0]?.url;
    return getCloudinaryURL(item?.media[0]?.url) ?? NoImage.src;
  };

  useEffect(() => {
    if (!openVariantCarousel) {
      handleSelectVariant(productVariants[0]);
    }
  }, [openVariantCarousel]);

  return (
    <div className={`flex flex-col`}>
      <div
        className="flex max-w-fit cursor-pointer gap-1 whitespace-nowrap"
        onMouseEnter={() => {
          if (!isMobile) {
            handleOpenVariantCarousel(true);
            setOnce(true);
          }
        }}
        onClick={() => {
          handleOpenVariantCarousel(!openVariantCarousel);
          setOnce(true);
        }}
      >
        <span className="text-sm leading-[18px] underline">
          {translations?.plp?.[
            productVariants.length > 1
              ? "plp_variant_count_multiple_label"
              : "plp_variant_count_single_label"
          ]?.replace("{{count}}", productVariants.length?.toString())}
        </span>
        <div className="flex items-center justify-center">
          <ChevronDown
            className={`${openVariantCarousel ? "rotate-180" : "rotate-0"} h-2 w-3 transition-transform duration-500 ease-in-out`}
          />
        </div>
      </div>
      <Collapse isOpen={openVariantCarousel} classname={"flex gap-2"}>
        <div className="overflow-hidden pt-[6px] md:px-4">
          <Carousel
            carouselOptions={{ loop: false, slidesToScroll: 3 }}
            spacing={8}
            autoPlay={{ playOnInit: false }}
            slides={productVariants?.map(
              (item, idx) =>
                ({
                  slideClasses: "basis-auto p-[2px]",
                  content: (
                    <div
                      key={idx}
                      className={`relative flex h-14 w-[54px] cursor-pointer items-center justify-center rounded-[5px] bg-tertiary-5 ${!item.inStock ? "opacity-50" : ""} ${selectedVariant.variantId === item.variantId && "outline outline-1"}`}
                      onClick={() => handleSelectVariant(item)}
                    >
                      {openVariantCarousel && once ? (
                        item?.media?.length > 0 ? (
                          <CldImage
                            src={getUrl(item)}
                            alt={item.variantName}
                            height={19}
                            width={54}
                            className="invert-[2%]"
                          />
                        ) : (
                          <img src={NoImage.src} height={19} width={54} />
                        )
                      ) : (
                        <></>
                      )}

                      {!openVariantCarousel && once ? (
                        item?.media?.length > 0 ? (
                          <CldImage
                            src={getUrl(item)}
                            alt={item.variantName}
                            height={19}
                            width={54}
                            className="invert-[2%]"
                          />
                        ) : (
                          <img src={NoImage.src} height={19} width={54} />
                        )
                      ) : (
                        <></>
                      )}

                      {!item.inStock && (
                        <div className="absolute h-[114%] rotate-45 rounded-lg border-[1px] border-tertiary-6 bg-tertiary-6 opacity-50"></div>
                      )}
                    </div>
                  ),
                }) as Slide,
            )}
            controls={{
              distance: "-15px",
              left: {
                top: "50%",
                content: (
                  <div className={cn("hidden", chevronEnabled ? "md:block" : "")}>
                    <ArrowLeftIcon className="text-tertiary-6" />
                  </div>
                ),
              },
              right: {
                top: "50%",
                content: (
                  <div className={cn("hidden", chevronEnabled ? "md:block" : "")}>
                    <ArrowRightIcon className="text-tertiary-6" />
                  </div>
                ),
              },
            }}
          />
        </div>
      </Collapse>
    </div>
  );
};

export default ProductVariantsCarousel;
